import React, { useEffect, useState } from 'react';
import {
    Checkbox,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControlLabel,
    TextField,
} from '@material-ui/core';
import { PrimaryButton, SecondaryButton } from '@/styles/blocks';

export default function SaveTemplateModal({ open, loadedTemplate, saving, onCancel, onSave }) {
    const [templateName, setTemplateName] = useState('');
    const [overwriteExisting, setOverwriteExisting] = useState(false);

    useEffect(() => {
        if (!open) return;
        setTemplateName(loadedTemplate?.name || '');
        setOverwriteExisting(false);
    }, [loadedTemplate, open]);

    const canOverwrite = Boolean(loadedTemplate?.cycle_count_template_id);
    const trimmedName = templateName.trim();
    const saveDisabled = saving || !trimmedName;
    const saveLabel = overwriteExisting && canOverwrite ? 'Overwrite' : 'Save';

    return (
        <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth>
            <DialogTitle>Save Template</DialogTitle>
            <DialogContent>
                <TextField
                    autoFocus
                    fullWidth
                    variant="outlined"
                    label="Template name"
                    value={templateName}
                    onChange={(e) => setTemplateName(e.target.value)}
                    margin="dense"
                />
                {canOverwrite ? (
                    <FormControlLabel
                        control={
                            <Checkbox
                                color="primary"
                                checked={overwriteExisting}
                                onChange={(e) => setOverwriteExisting(e.target.checked)}
                            />
                        }
                        label={`Overwrite existing template (${loadedTemplate.name})`}
                    />
                ) : null}
            </DialogContent>
            <DialogActions>
                <SecondaryButton onClick={onCancel} disabled={saving}>
                    Cancel
                </SecondaryButton>
                <PrimaryButton
                    onClick={() => onSave({ name: trimmedName, overwrite: overwriteExisting && canOverwrite })}
                    disabled={saveDisabled}
                >
                    {saveLabel}
                </PrimaryButton>
            </DialogActions>
        </Dialog>
    );
}
